import { collapsibleExpandEvent, collapsibleName, triggerTagName } from '@/components/utils';
import { Component, defineComponent } from '@decify/cell-shopify/client';
import './AccordionItem.scss';
export const accordionItemName = 'AccordionItem';
export const accordionItemTagName = 'cell-component-accordion-item';
export const accordionItemExpandEvent = 'expand';
export class AccordionItem extends Component {
    constructor() {
        super(accordionItemName);
        this.handleExpand = this.handleExpand.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${collapsibleName}.${collapsibleExpandEvent}`, this.handleExpand);
    }
    handleExpand() {
        this.publish(accordionItemExpandEvent);
    }
    collapse() {
        if (this.controlElement.getAttribute('aria-expanded') === 'true') {
            this.controlElement.click();
        }
    }
    get controlElement() {
        const controlElement = this.querySelector(triggerTagName);
        if (!controlElement) {
            throw new Error('AccordionItem must have a trigger element');
        }
        if (!(controlElement instanceof HTMLElement)) {
            throw new Error('AccordionItem trigger element must be an HTMLElement');
        }
        return controlElement;
    }
}
defineComponent(accordionItemTagName, AccordionItem);
